import React, { useEffect, useState } from "react";
import { Grid, Box, Typography, Button, IconButton } from "@mui/material";
import BackgroundImage from "../policyholderCover.png";
import openIMIS from "../assets/openIMIS.png";
import { RouterProvider } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import LocalizationDropdown from "../reusableComponents/components/generics/LocalizationDropdown"
import { useTranslation } from "react-i18next";

function AuthLayout({
  children,
  backButtonClick,
  accountMsg,
  buttonClick,
  buttonName,
  imageTitle,
  imageSubtitle,
  isFosa
}) {
  const { i18n } = useTranslation();
  const [language, setLanguage] = useState(localStorage.getItem('selectedLanguage') || 'fr');
  const handleLanguageChange = (event) => {
    i18n.changeLanguage(event.target.value);
    setLanguage(event.target.value);
    localStorage.setItem('selectedLanguage', event.target.value);
  };

  useEffect(() => {
    const storedLanguage = localStorage.getItem('selectedLanguage');
    if (storedLanguage) {
      i18n.changeLanguage(storedLanguage);
    }
    else {
      localStorage.setItem('selectedLanguage', 'fr');
    }
  }, []);
  // const { t } = useTranslation();
  return (
    <Grid sx={{ display: "flex" }}>
      <Grid className="image-container">
        <img src={BackgroundImage} alt="Logo" className="background-image" />
        <img src={openIMIS} alt="Logo" className="logo-sign" />
        <div className="text-overlay">
          <h1 > {imageTitle}</h1>
          <h3>{imageSubtitle}</h3>
        </div>
      </Grid>
      <Box className="auth-container">
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-evenly",
            marginTop: "1rem",
            // paddingLeft: "1rem",
            // paddingRight: "1rem",
          }}
        >
          {/* <Typography component="span" sx={{ display: 'flex', width: "15.625rem", alignItems: "center" }}>
            <IconButton onClick={backButtonClick}>
              <ArrowBackIcon />
            </IconButton>
            <Typography>{t("Back to CAMU Cg")}</Typography>
          </Typography> */}
          <Grid container sx={{ alignItems: 'center', display: "flex", justifyContent: "space-between", marginLeft: "1rem" }}>
            <Grid item>
              <LocalizationDropdown
                handleLanguageChange={handleLanguageChange}
                language={language}
              />
            </Grid>
            {isFosa ? "" : <Typography component="span" pointer sx={{ marginLeft: '1rem' }}>
              {accountMsg ? accountMsg + " " : ""}
              <Button
                color="primary"
                variant="outlined"
                onClick={buttonClick}
                className="ml-2"
              >
                {buttonName}
              </Button>
            </Typography>}
          </Grid>
        </Box>
        <Grid container>{children}</Grid>
      </Box>
    </Grid>
  );
}

export default AuthLayout;
